import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CloudRoutingModule } from './cloud-routing.module';
import { CloudDetailsComponent } from './cloud-details/cloud-details.component';
import { CloudSubscriptionComponent } from './cloud-subscription/cloud-subscription.component';
import { CloudAccessComponent } from './cloud-access/cloud-access.component';
import { CloudDownloadComponent } from './cloud-download/cloud-download.component';
import { SharedModule } from '../shared/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { CloudEffects } from './store/effects/cloud.effects';
import { DownloadDesktopComponent } from './cloud-download/download-desktop/download-desktop.component';
import { DownloadMobileComponent } from './cloud-download/download-mobile/download-mobile.component';
import { CloudService } from './services/cloud.service';
import {
  AlertModule,
  LoadingSpinnerModule,
} from '@proximus/ng-common-components';
import { FormsModule } from '@angular/forms';
import { TranslationModule } from '@proximus/ng-common';

@NgModule({
  declarations: [
    CloudDetailsComponent,
    CloudSubscriptionComponent,
    CloudAccessComponent,
    CloudDownloadComponent,
    DownloadDesktopComponent,
    DownloadMobileComponent,
  ],
  imports: [
    CommonModule,
    CloudRoutingModule,
    SharedModule,
    EffectsModule.forFeature([CloudEffects]),
    TranslationModule,
    LoadingSpinnerModule,
    AlertModule,
    FormsModule,
  ],
  providers: [CloudService],
})
export class CloudModule {}
